export class TrackingNotice {
    constructor(category, action, label) {
        this.type = "tracking";
        this.category = category;
        this.action = action;
        this.label = label;
    }
}
